import { AxiosInstance } from 'axios';
import { FacilityContextRepository } from '@/model/repository/manager/facilityContext/FacilityContextRepository';

export default (Repository: AxiosInstance) =>
  (resource: string): FacilityContextRepository => ({
    index() {
      return Repository.get(resource, {});
    },
  });
